// payrollTemplate.js (Service File)
import axiosInstance from "../Axios";

function getPayrollTemplates(pageNo = 1, params) {
  try {
    const queryParams = { pageNo };
    if (params && Object.keys(params).length > 0) {
      Object.assign(queryParams, params);
    }
    return axiosInstance.get("/payroll/templates", { params: queryParams });
  } catch (error) {
    console.log("Error while fetching payroll templates:", error);
    throw error;
  }
}

// Unpaginated - for the template picker on the wage-rate form.
function getActivePayrollTemplates(payBasis) {
  try {
    return axiosInstance.get("/payroll/templates/active", { params: { pay_basis: payBasis } });
  } catch (error) {
    console.log("Error while fetching active payroll templates:", error);
    throw error;
  }
}

function getPayrollTemplateDetails(id) {
  try {
    return axiosInstance.get(`/payroll/templates/${id}`);
  } catch (error) {
    console.log("Error fetching payroll template details:", error);
    throw error;
  }
}

function createPayrollTemplate(data) {
  try {
    return axiosInstance.post("/payroll/templates", data);
  } catch (error) {
    console.log("Error while creating payroll template:", error);
    throw error;
  }
}

function updatePayrollTemplate(id, data) {
  try {
    return axiosInstance.put(`/payroll/templates/${id}`, data);
  } catch (error) {
    console.log("Error while updating payroll template:", error);
    throw error;
  }
}

function deletePayrollTemplate(id) {
  try {
    return axiosInstance.delete(`/payroll/templates/${id}`);
  } catch (error) {
    console.log("Error while deleting payroll template:", error);
    throw error;
  }
}

export {
  getPayrollTemplates,
  getActivePayrollTemplates,
  getPayrollTemplateDetails,
  createPayrollTemplate,
  updatePayrollTemplate,
  deletePayrollTemplate,
};
